import {
  ResourceContextProvider,
  SimpleForm,
  Title,
  useNotify,
} from "react-admin";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BackButtonToolbar from "features/BackButtonToolbar";
import { dormitoryRequests } from "api/dormitoryApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";
import { ACCOMMODATION_PRICES, DormitoryServicePath, PRICES, ROOM_TYPES } from "utils/constants";
import SaveForm from "../SaveForm";

const CreateAccommodationPrice = () => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const navigate = useNavigate();
  const { typeId } = useParams();
  const roomTypeName = useLocation().state?.roomTypeName;

  const handleSubmit = async data => {
    try {
      await dataProvider.customRequest(
        dormitoryRequests.createAccommodationPrice(typeId),
        {
          amount: data.amount,
          orderNumber: data.orderNumber,
          receptionTypeId: data.receptionTypeId,
          studentType: data.studentType,
          course: data.course,
          validFrom: data.validFrom,
          validTo: data.validTo,
        },
        "POST",
      );
      notify("Успешно създаване на цена за настаняване", { type: "success" });
      navigate(`/${DormitoryServicePath}${ACCOMMODATION_PRICES}`);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <>
      <Title
        title={
          roomTypeName
            ? `Създаване на цена за настаняване: ${roomTypeName}`
            : "Създаване на цена за настаняване"
        }
      />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${DormitoryServicePath}${ROOM_TYPES}/${typeId}/${PRICES}/create`}>
        <SimpleForm onSubmit={handleSubmit}>
          <SaveForm />
        </SimpleForm>
      </ResourceContextProvider>
    </>
  );
};

export default CreateAccommodationPrice;
